import { ButtonFileSelect } from 'src/components/ButtonFileSelect'
import { ButtonMui } from 'src/components/ButtonMui'
import MultipleSelect from 'src/components/MultipleSelect/MultipleSelect'
import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const FilterContainer = styled.div`
    display: flex;
    margin-bottom: 1.6rem;
    margin-top: 0.7rem;
    gap: 1.4rem;
    align-items: center;
    height: 3rem !important;
`

export const CustomButton = styled(ButtonMui)`
    width: 32rem;    
    height: 3rem !important;
    margin: 0 !important;
`

export const CustomButtonDownloadTemplate = styled(ButtonMui)`
    width: 32rem;    
    height: 3rem !important;
    margin: 0 !important;
`

export const CustomSelect = styled(SelectMui)`
    margin: 0 !important;
    height: 3rem !important;
`

export const CustomMultipleSelect = styled(MultipleSelect)`
    margin: 0 !important;
    height: 3rem !important;
`

export const CustomSelectWrapper = styled.div`
    display: flex;
    width: 160%;
    gap: 1.4rem;
    margin-bottom: 0;
    height: 3rem !important;
`

export const SelectFileContainer = styled.div`
    display: flex;
    justify-content: end;
    width: 100%;
    gap: 1.2rem;
`

export const FileContainer = styled.div`
    display: flex;
    justify-content: end;
    width: 100%;
    gap: .2rem;
`

export const CustomButtonDetach = styled.button`
    width: 16px;
    height: 20px;
    border-style: none;
    color: red;
    background: none;
    font-size: small;
`

export const CustomButtonFileSelect = styled(ButtonFileSelect)`
`

export const ErrorsMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
    width: 100%;
    margin-bottom: 1.4rem;
`

export const ErrorsSubContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    max-width: 31.7rem;
    gap: .3rem;
`

export const ErrorsContainer = styled.div`
    max-height: 100px;
    overflow-y: auto;
    display: flex;
`
